import React from 'react'
import { InviteStatus } from 'components/AccessLevelSelect/types'
import { BaseRow, BaseInfo, BaseAvatar } from '../BaseRow'

import {
  ProjectMembershipFragment,
  WorkspaceMembershipFragment,
} from '@sketch/gql-types'

type MemberRowProps = {
  identifier: string
  email: string
  name: string
  avatarSrc?: string | null
  inviteStatus?: ProjectMembershipFragment['inviteStatus'] | InviteStatus
  role: WorkspaceMembershipFragment['role']
  actions: React.ReactNode
}

export const MemberRow = ({
  identifier,
  email,
  name,
  avatarSrc = '',
  role,
  inviteStatus,
  actions,
}: MemberRowProps) => (
  <BaseRow
    identifier={email}
    ariaLabel={`Row of ${name || email}`}
    name={name}
    avatar={
      <BaseAvatar src={avatarSrc} name={`${name || email} avatar`}></BaseAvatar>
    }
    actions={actions}
  >
    <BaseInfo
      identifier={identifier}
      title={name}
      subtitle={email}
      inviteStatus={inviteStatus}
      role={role}
    />
  </BaseRow>
)

interface WorkspaceMemberRowProps {
  workspaceMembership: Pick<
    WorkspaceMembershipFragment,
    'role' | 'user' | 'invite'
  >
  inviteStatus?: ProjectMembershipFragment['inviteStatus'] | InviteStatus
  actions: React.ReactNode
}

export const WorkspaceMemberRow = ({
  workspaceMembership,
  inviteStatus,
  actions,
}: WorkspaceMemberRowProps) => {
  const memberName = workspaceMembership.user?.name || ''
  const memberEmail =
    workspaceMembership.user?.email || workspaceMembership.invite?.email || ''

  return (
    <MemberRow
      identifier={workspaceMembership.user?.identifier || memberEmail}
      email={memberEmail}
      name={memberName}
      avatarSrc={workspaceMembership.user?.avatar?.small}
      inviteStatus={inviteStatus}
      role={workspaceMembership.role}
      actions={actions}
    />
  )
}
